/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />
/// <reference path="./openCloseHistory.controller.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class OpenCloseHistory implements angular.IDirective {
        restrict = "E";
        templateUrl = "app/components/controls/openCloseHistory/openCloseHistory.template.html";
        scope = {
            openOnDate: '=',
            closeOnDate: '=',
            openOnTime: '=',
            closeOnTime: '=',
            securityAccess: "=?",
            disabled: '=?ngDisabled',
            model: '=?ngModel',
            modelKey: '@?',
            showSeconds: '=?',
            showAmPm: '=?',
            isHidden: '=?',
        };
        bindToController = true;
        controller = Meevo.Components.Controls.OpenCloseHistoryController;
        controllerAs = '$ctrl';
        require = 'meevoOpenCloseHistory';
        link = (scope: angular.IScope, element: JQuery, attr: angular.IAttributes, ctrl) => {
            ctrl.init();
        };

        static factory(): angular.IDirectiveFactory {
            return () => {
                return new OpenCloseHistory();
            };
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoOpenCloseHistory", OpenCloseHistory.factory());
}